<template>
  <div class="workbench-container cso-cockpit">
    <div class="workbench-body">
      <CsoHeaderCard />
      <div class="workbench">
        <div class="brief-grid">
          <div class="brief-grid-item">
            <EnterpriseWarRoom
              :key="agentId"
              :agent-id="agentId"
              @open-detail="$emit('open-detail', $event)"
              @open-list="$emit('open-list', $event)"
              @smart-analysis="$emit('smart-analysis', $event)"
              @start-chat="$emit('start-chat', $event)"
            />
          </div>
          <div class="brief-grid-item">
            <TaskQueue
              :key="agentId"
              :agent-id="agentId"
              @open-detail="(taskData) => $emit('task-open-detail', taskData)"
              @open-list="$emit('task-open-list', $event)"
            />
          </div>
          <div class="brief-grid-item">
            <PendingDecisions
              :key="agentId"
              @smart-analysis="$emit('smart-analysis', $event)"
              @open-detail="$emit('decision-open-detail', $event)"
              @open-list="$emit('decision-open-list', $event)"
            />
          </div>
        </div>
        <!-- <div class="flex-container gap-10">
        <div class="flex-item-2">
          <EnterpriseWarRoom
            :agent-id="agentId"
            @open-detail="$emit('open-detail', $event)"
            @open-list="$emit('open-list', $event)"
            @smart-analysis="$emit('smart-analysis', $event)"
            @start-chat="$emit('start-chat', $event)"
          />
        </div>
        <div class="flex-item">
          <TaskQueue
            :agent-id="agentId"
            @open-detail="(taskData) => $emit('task-open-detail', taskData)"
            @open-list="$emit('task-open-list', $event)"
          />
        </div>
      </div> -->
        <CsoCoreIndicators
          :dashboard-data="dashboardData"
          :dashboard-loading="dashboardLoading"
          @smart-analysis="$emit('smart-analysis', $event)"
        />
        <div v-if="showAnalysisCards" class="analysis-grid">
          <CsoProcurementCost
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
          <CsoCoreKpi
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
          <CsoStrategyProgress
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
        </div>
        <CsoSankeyChart :key="agentId"
          @smart-analysis="$emit('smart-analysis', $event)"
          @open-price-management="$emit('open-price-management')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CsoHeaderCard from './components/CsoHeaderCard.vue'
import EnterpriseWarRoom from '../components/EnterpriseCard.vue'
import TaskQueue from '../components/TaskQueue.vue'
import PendingDecisions from '../components/PendingDecisions.vue'
import CsoCoreIndicators from './components/CsoCoreIndicators.vue'
import CsoProcurementCost from './components/CsoProcurementCost.vue'
import CsoCoreKpi from './components/CsoCoreKpi.vue'
import CsoStrategyProgress from './components/CsoStrategyProgress.vue'
import CsoSankeyChart from './components/CsoSankeyChart.vue'
import { getSupplyChainDashboard } from '@/api/supply-chain'
import { getAgentIdByInternalName } from '@/store/modules/cosmoClaw'
import { isLargeVolumeTenant } from './utils/largeVolumeTenant'
import { mapState } from 'vuex'

export default {
  name: 'CsoWorkbench',
  components: {
    CsoHeaderCard,
    EnterpriseWarRoom,
    TaskQueue,
    PendingDecisions,
    CsoCoreIndicators,
    CsoProcurementCost,
    CsoCoreKpi,
    CsoStrategyProgress,
    CsoSankeyChart
  },
  data() {
    return {
      dashboardData: {},
      dashboardLoading: true
    }
  },
  computed: {
    ...mapState('user', ['agentList']),
    // 大数据量租户（创智物联 / tenantId 720813）：其数据源没有这三张卡的指标，
    // 故整块分析区不渲染。判定与桑基图「影响金额」默认下限共用 largeVolumeTenant。
    showAnalysisCards() {
      return !isLargeVolumeTenant()
    },
    // 数字人 agentId 优先取 URL query.agentId（同路由多实例切换），无则从 agentList 自动匹配
    agentId() {
      const queryAgentId = (this.$route.query && this.$route.query.agentId) || ''
      if (queryAgentId) {
        const list = Array.isArray(this.agentList) ? this.agentList : []
        const matched = list.find(
          (a) =>
            String(a.id) === String(queryAgentId) ||
            String(a.agentId || '') === String(queryAgentId)
        )
        if (matched) return String(queryAgentId)
      }
      return getAgentIdByInternalName('gong_ying_lian_shu_zi_ren', this.agentList)
    }
  },
  created() {
    this.fetchDashboard()
  },
  mounted() {
    if (this.agentId) {
      this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', this.agentId)
    }
  },
  watch: {
    agentId(val) {
      if (val) {
        this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', val)
      }
      this.fetchDashboard()
    }
  },
  methods: {
    async fetchDashboard() {
      this.dashboardLoading = true
      try {
        const res = await getSupplyChainDashboard()
        this.dashboardData = res && res.data ? res.data : {}
      } catch (error) {
        console.error('获取供应链驾驶舱数据失败:', error)
      } finally {
        this.dashboardLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/cso-cockpit.scss";

.workbench-container {
  height: 100%;
  padding: 24px;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.workbench-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.workbench {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
  box-sizing: border-box;
}
.workbench::-webkit-scrollbar {
  width: 4px;
}
.workbench::-webkit-scrollbar-track {
  background: transparent;
}
.workbench::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}

.brief-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  min-width: 700px;
  flex-shrink: 0;
}

.brief-grid-item {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
}

.analysis-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr) minmax(0, 1fr);
  gap: 10px;
  width: 100%;
  min-width: 700px;
  flex-shrink: 0;
  align-items: stretch;
  grid-auto-rows: minmax(250px, auto);
}

.analysis-grid > .cso-panel {
  height: 100%;
  min-width: 0;
}

.grid-1 {
  width: 100%;
  min-width: 700px;
}

.gap-10 {
  gap: 10px;
}
.flex-container {
  width: 100%;
  min-width: 700px;
  display: flex;
}
.flex-item {
  width: calc((100% - 10px) / 3);
  flex-shrink: 1;
  min-width: 0;
}
.flex-item-2 {
  width: calc((100% - 10px) / 3 * 2);
  flex-shrink: 1;
  min-width: 0;
}
.gap-10 {
  gap: 10px;
}
</style>
